//librerias
import { HttpParams } from "@angular/common/http";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { NgbTooltip } from "@ng-bootstrap/ng-bootstrap";
import {
  NgxQrcodeElementTypes,
  QrcodeComponent,
} from "@techiediaries/ngx-qrcode";
//interfaces
import { ICourseSession } from "src/app/attendanceRecord/interfaces/SessionsInterface";
import { replaceFileNotAllowedCharacters } from "src/app/shared/utils/normalizeStrings";
//otros
import { environment } from "src/environments/environment";

@Component({
  selector: "app-modal-course-card",
  templateUrl: "./modal-course-card.component.html",
  styleUrls: ["./modal-course-card.component.css"],
})
export class ModalCourseCardComponent implements OnInit {
  @Input() data!: ICourseSession;
  title = "";
  elementType: NgxQrcodeElementTypes = NgxQrcodeElementTypes.URL;
  urlToRedirect: string = "";
  numeroSessiones: any = [];
  selectedSession: number = 1;
  @ViewChild("QR") qrView?: QrcodeComponent;
  @ViewChild("tooltip") tooltip!: NgbTooltip;
  @Output()
  closeModalEmitter = new EventEmitter<boolean>();

  constructor() {}
  ngOnInit() {
    this.numeroSessiones = [];
    this.urlToRedirect = this.construirURL(this.data, this.selectedSession);
    this.title = this.data?.titulo;
    for (let i = 1; i <= this.data?.TotalPartes; i++) {
      this.numeroSessiones.push(`Session ${i} : ${i}`);
    }
  }

  updateValue() {
    this.urlToRedirect = this.construirURL(this.data, this.selectedSession);
  }

  construirURL(data: ICourseSession, sessionNumber: number): string {
    const apiUrl = `${environment.QrUri}#/registrarAsistencia`;

    const params = new HttpParams()
      .set("fkIdSesion", data.Id)
      .set("numeroSesion", sessionNumber.toString());

    const parametrosBase = btoa(params.toString());
    console.log(params.toString());
    const parametrosUrl = encodeURIComponent(parametrosBase);

    const urlCompleta = `${apiUrl}?${parametrosUrl}`;

    return urlCompleta;
  }

  saveQr() {
    if (!this.qrView) {
      return;
    }
    const imageName = `QR_${this.data.titulo}_Sesion_${this.selectedSession}`;
    // Obtener la URL de la imagen del código QR
    const qrImageSrc = this.qrView.qrcElement.nativeElement.firstChild.src;
    const downloadLink = document.createElement("a");
    downloadLink.href = qrImageSrc;
    downloadLink.download = replaceFileNotAllowedCharacters(imageName, "-");
    downloadLink.click();
  }

  copyUrl() {
    this.tooltip.open();
    const aux = document.createElement("input");
    aux.setAttribute("value", this.urlToRedirect);
    document.body.appendChild(aux);
    aux.select();
    document.execCommand("copy");
    document.body.removeChild(aux);
    setTimeout(() => {
      this.tooltip.close();
    }, 1500);
  }

  closeModal() {
    this.closeModalEmitter.emit(true);
  }
}
